module.exports = "<svg style=\"width: 14px; height: 11px\" viewBox=\"1 3 14 11\"><polygon id=\"path-1\" points=\"5.91421356 13.4497475 14.5710678 4.79289322 13.1568542 3.37867966 5.91421356 10.6213203 3.08578644 7.79289322 1.67157288 9.20710678\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/check.svg
// module id = 608
// module chunks = 0